var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOverlayVisible)?_c('div',{staticClass:"ui-overlay",on:{"click":_vm.close}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }